import { DocumentsReportCategoryDTO } from "../../models/documents/documents-reports";

export const getReportCategoryGroups = (items: DocumentsReportCategoryDTO[], id: string) => {
  return items.find((item: DocumentsReportCategoryDTO) => item.reportCategory?.id === id)?.reportCategoryGroups ?? [];
};
